import { getCounsellorNameEndpoint } from '@cont/OfflineCentres/apiHelper';
import useFetch from '@hooks/useFetch';

const useCounsellorName = (counsellor) => {
  const {
    data: counsellorName,
    isLoading: isCounsellorNameLoading,
    ...rest
  } = useFetch(counsellor ? getCounsellorNameEndpoint(counsellor) : null, {
    useCamelCase: false
  });
  return { counsellorName, isCounsellorNameLoading, ...rest };
};

export default useCounsellorName;
